module.exports = __webpack_public_path__ + "media/icons/wheelchair-stamp-10bcac23.svg";